import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Junta classes condicionais (clsx) e resolve conflitos de Tailwind (twMerge).
 *
 * O twMerge é o que faz `cn('p-2', 'p-4')` virar `p-4` em vez de `p-2 p-4` —
 * sem ele, a prop `className` de um componente não conseguiria sobrescrever o
 * default dele, que é o ponto inteiro do padrão shadcn.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
